module.exports = __webpack_public_path__ + "static/media/thumbnail.a6aaaa54.jpg";